import { DeliveryIndicator } from "./DeliveryIndicator";
import { cn } from "../utils/cn";

type DeliveryState = "pending" | "sent" | "delivered" | "read";

export interface MessageBubbleProps {
  content: string;
  timestamp: string;
  isOwn: boolean;
  deliveryState?: DeliveryState;
  deliveryLabel?: string;
}

export function MessageBubble({
  content,
  timestamp,
  isOwn,
  deliveryState,
  deliveryLabel,
}: MessageBubbleProps) {
  return (
    <div className={cn("flex flex-col gap-1", isOwn ? "items-end" : "items-start")}>
      <div
        className={cn(
          "max-w-[80%] rounded-2xl px-4 py-2 text-sm shadow-sm ring-1",
          isOwn
            ? "bg-sky-600 text-white ring-sky-500"
            : "bg-white text-slate-900 ring-slate-200 dark:bg-slate-900 dark:text-slate-100 dark:ring-slate-700"
        )}
      >
        {content}
      </div>
      <span className="flex items-center gap-1 text-[11px] uppercase tracking-wide text-slate-400 dark:text-slate-500">
        {new Date(timestamp).toLocaleString()}
        {deliveryState && deliveryLabel ? (
          <DeliveryIndicator state={deliveryState} label={deliveryLabel} />
        ) : null}
      </span>
    </div>
  );
}
